// Opener registry — single source of truth for available presets and
// their current schema version. Future presets register here.

import RainOnCotton from './presets/rainOnCotton/RainOnCotton';
import { defaults as rainOnCottonDefaults, combos as rainOnCottonCombos } from './presets/rainOnCotton/defaults';
import { schema as rainOnCottonSchema } from './presets/rainOnCotton/schema';

export const RAIN_ON_COTTON_ID = 'rain-on-cotton-paper';

export const PRESETS = {
  [RAIN_ON_COTTON_ID]: {
    id: RAIN_ON_COTTON_ID,
    name: 'Rain on Cotton Paper',
    thumbnail: null, // static still added in PRD follow-up; designers see live preview
    version: 1,
    defaults: rainOnCottonDefaults,
    combos: rainOnCottonCombos,
    schema: rainOnCottonSchema,
    Component: RainOnCotton,
  },
};

export const PRESET_LIST = Object.values(PRESETS);

export function getPreset(presetId) {
  return PRESETS[presetId] || null;
}
